import React from "react";

const NotificationSettingsIcon = () => (
  <svg width="60" height="60" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="42" height="42" fill="white" />
    <path
      d="M17.0078 1.28272V5.29297"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3849 37.3754C20.3849 39.218 18.8857 40.7173 17.043 40.7173C15.2004 40.7173 13.7012 39.218 13.7012 37.3754"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.9914 31.7435C33.377 33.8011 31.8004 35.7041 29.7069 35.7041H4.34275C2.24924 35.7041 0.672708 33.8011 1.05828 31.7435C2.17455 25.7868 5.64633 24.2101 5.64633 19.1618V16.6554C5.64633 10.4574 10.6758 5.37711 16.8551 5.29406H17.1623"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8887 5.29457H17.196C19.1239 5.32047 20.9368 5.83287 22.5187 6.71387"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1504 14.0991H40.8108"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1504 23.9575H40.8108"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="24.0513"
      cy="24.9434"
      r="2.95756"
      fill="white"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="33.9107"
      cy="13.1133"
      r="2.95756"
      fill="white"
      stroke="black"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { NotificationSettingsIcon };
